<div class="h-full w-full si-card">
  <div class="flex flex-row grow-0 border-b px-4 py-2">
    <div class="flex grow items-center">
      <h3 class="pt-2 whitespace-nowrap">VisitorIntel</h3>
    </div>

    <div class="flex grow-0 items-center">
      <button *ngIf="!isVisitorIntelSetupDone"
              matButton="outlined"
              type="button"
              class="mat-small-button card-btn"
              [disabled]="true"
      >
        View All
      </button>
    </div>

    <div class="flex grow-0 items-center" *ngIf="isVisitorIntelSetupDone && visitorIntelAgents?.length !== 0">
      @if (!hideAgentSelector) {
      <div [matTooltip]="selectedOption?.name || 'All Agents'">
        <button matButton="outlined" type="button"
                class="mr-1 card-menu si-menu-trigger" [matMenuTriggerFor]="intentAgentsMenu" [disabled]="visitorIntelAgents?.length === 0">
          <span class="si-card-menu-content">
            <span class="si-card-menu-label">{{ selectedOption?.name || 'All Agents' }}</span>
            <span class="si-menu-trigger-icon" aria-hidden="true"></span>
          </span>
        </button>
      </div>
      <mat-menu #intentAgentsMenu>
        <ng-template matMenuContent>
          <button mat-menu-item (click)="updateSelectedOption({ isAllAgents: true })">
            All Agents
          </button>
          <button mat-menu-item *ngFor="let agent of visitorIntelAgents" (click)="updateSelectedOption(agent)">
            {{ agent.name }}
          </button>
        </ng-template>
      </mat-menu>
      }

      <mat-button-toggle-group name="type" class="mr-1 card-toggle-btn">
        <mat-button-toggle
          value="CHART"
          [checked]="isShowChart"
          (change)="isShowChart = true"
          class="flex items-center"
        >
          <fa-icon matTooltip="Chart" class="si-icon" [icon]="['fal', 'chart-column']"></fa-icon>
        </mat-button-toggle>
        <mat-button-toggle
          value="TABLE"
          [checked]="!isShowChart"
          (change)="isShowChart = false"
          class="flex items-center"
        >
          <fa-icon matTooltip="Table" class="si-icon" [icon]="['fal', 'table']"></fa-icon>
        </mat-button-toggle>
      </mat-button-toggle-group>

      <div [matTooltip]="!selectedOption ? 'View all only available when an individual VisitorIntel Agent is selected.' : (isWeeklyAgentsNotRun ? 'View all is disabled while this agent has not run yet.' : '')">
        <button
          matButton="outlined"
          type="button"
          class="mat-small-button card-btn"
          (click)="viewAllPastWeekVisitorIntelData()"
          [disabled]="!selectedOption || isWeeklyAgentsNotRun"
        >
          View All
        </button>
      </div>
    </div>
  </div>

  <div class="h-full" *ngIf="isLoading; else showVIContent">
    <div class="flex justify-center items-center h-full w-full">
      <mat-spinner></mat-spinner>
    </div>
  </div>

  <ng-template #showVIContent>
    @if(!isVisitorIntelSetupDone) {
      <div class="flex pb-3 pt-1 px-2 flex-wrap justify-center content-start h-full overflow-auto">
        <p class="text-center pb-2 text-secondary empty-state-text font-light">
          Know who’s visiting your website. Turn anonymous traffic into in-market prospects.
          <a href="https://support.salesintel.io/hc/en-us/articles/17094399359001-Use-VisitorIntel">Install VisitorIntel</a>
          to get started.
        </p>
        <div class="px-4">
          <app-visitor-intel-script [textareaRows]="5" titleClasses="text-secondary no-underline"></app-visitor-intel-script>
        </div>
      </div>
    } @else {
      <ng-container *ngIf="(visitorIntelAgents?.length !== 0 || visitorIntelData?.length !== 0)">
        <div class="flex w-full h-full flex-col p-4 items-center overflow-hidden" *ngIf="visitorIntelAgents?.length === 0">
          <p class="card-sub-header-text w-full">
            Visitors over the past 7 days
          </p>
          <ng-container *ngIf="isShowChart; then chartPlaceholder; else tablePlaceholder" class="h-full w-full"></ng-container>
          <p
            class="text-center pt-2 text-secondary w-full font-light"
            *ngIf="
              isAdmin &&
                ([addonsIdentifiersEnum.VISITORINTEL]
                | hasPlans | async) &&
                featureFlagsEnum.VisitorIntelAutomations
                | isFeatureFlagEnabled
                | async
            "
          >
            Set up an
            <ng-container *ngIf="featureFlagsEnum.GTMCanvas | isFeatureFlagEnabled | async; else legacyLink">
              <a [routerLink]="resultTabsetUrlsEnum.AGENTIC_WORKFLOWS" class="text-primary">agent</a>
            </ng-container>
            <ng-template #legacyLink>
              <a (click)="onOpenSettings(modalNavigationEnum.VISITOR_INTEL_AUTOMATIONS)" class="text-primary">agent</a>
            </ng-template>
            to export visitors to your CRM
          </p>
        </div>

        <div class="flex w-full h-full flex-col p-4 items-center overflow-hidden" *ngIf="!selectedOption.isAllAgents && !isWeeklyAgentsNotRun && visitorIntelAgents?.length !== 0;">
          <ng-container *ngIf="selectedOption?.email_only; else exportedDeatails">
            <p class="card-sub-header-text w-full">
              Visitors in the past 7 days
            </p>
            <ng-container *ngIf="isShowChart; then chartPlaceholder; else visitorTable" class="h-full w-full"></ng-container>
          </ng-container>
          <ng-template #exportedDeatails>
            <p class="card-sub-header-text">
              Companies and contacts exported over the past 7 days
            </p>
            <ng-container *ngIf="isShowChart; then lineChart; else exportTable" class="h-full w-full"></ng-container>
          </ng-template>
        </div>

        <div class="flex w-full h-full flex-col p-4 items-center overflow-hidden"
             *ngIf="selectedOption.isAllAgents && !isWeeklyAgentsNotRun && visitorIntelAgents?.length !== 0;">
          <ng-container *ngIf="isAllAgentsEmailOnly; then emailOnlyReport"></ng-container>
          <ng-container *ngIf="isAllAgentsExportOnly; then showexportGraphAndTable"></ng-container>
          <ng-container *ngIf="!isAllAgentsEmailOnly && !isAllAgentsExportOnly; then showCombinedGraphAndTable"></ng-container>
          <ng-template #showCombinedGraphAndTable>
            <p class="card-sub-header-text w-full">All VisitorIntel Agent activity over the past 7 days</p>
            <ng-container *ngIf="isShowChart; then lineChart; else allCombinedTable" class="h-full w-full"></ng-container>
          </ng-template>
        </div>

        <ng-template #emailOnlyReport>
          <p class="card-sub-header-text">Visitors over the past 7 days</p>
          <ng-container *ngIf="isShowChart; then chartPlaceholder; else emailOnlyTable"></ng-container>
        </ng-template>

        <ng-template #showexportGraphAndTable>
          <p class="card-sub-header-text">Companies and contacts exported over the past 7 days</p>
          <ng-container *ngIf="isShowChart; then lineChart; else combinedTable" class="h-full w-full"></ng-container>
        </ng-template>

        <ng-template #chartPlaceholder>
          <div class="h-full w-full">
            <app-bar-chart
              [chartLabels]="chartDataLabels"
              [chartData]="chartData"
              [showDataLabel]="true"
              [showHorizontalGridLines]="true"
              [showTooltips]="false"
              [ngClass]="tableClass"
              [useAbbreviationYAxis]="true"
            ></app-bar-chart>
          </div>
        </ng-template>

        <ng-template #tablePlaceholder>
          <div class="h-full w-full flex flex-col overflow-hidden">
            <app-data-table
              [data]="visitorIntelData"
              [columns]="columns"
              sortActive="event_date"
              sortDirection="asc"
              smallRowHeight="true"
              [layoutFixed]="false"
            ></app-data-table>
          </div>
        </ng-template>

        <ng-template #lineChart>
          <div class="flex flex-col h-full w-full overflow-hidden">
            <app-line-chart class="flex flex-col w-full h-full" [chartData]="chartData" [chartLabels]="chartDataLabels" legendKeyToHide="All Companies"></app-line-chart>
          </div>
        </ng-template>

        <ng-template #exportTable>
          <div class="h-full w-full flex flex-col overflow-hidden">
            <app-data-table
              [data]="tableData"
              [columns]="exportColumns"
              sortActive="job_date"
              sortDirection="asc"
              smallRowHeight="true"
              [layoutFixed]="false"
            ></app-data-table>
          </div>
        </ng-template>

        <ng-template #visitorTable>
          <div class="h-full w-full flex flex-col overflow-hidden">
            <app-data-table
              [data]="tableData"
              [columns]="visitorColumns"
              sortActive="job_date"
              sortDirection="asc"
              smallRowHeight="true"
              [layoutFixed]="false"
            ></app-data-table>
          </div>
        </ng-template>

        <ng-template #emailOnlyTable>
          <div class="h-full w-full flex flex-col overflow-hidden">
            <app-data-table
              [data]="tableData"
              [columns]="emailOnlyColumns"
              sortActive="job_date"
              sortDirection="asc"
              smallRowHeight="true"
              [layoutFixed]="false"
            ></app-data-table>
          </div>
        </ng-template>

        <ng-template #combinedTable>
          <div class="h-full w-full flex flex-col overflow-hidden">
            <app-data-table
              [data]="tableData"
              [columns]="exportOnlyColumns"
              sortActive="week_start"
              sortDirection="asc"
              smallRowHeight="true"
              [layoutFixed]="false"
            ></app-data-table>
          </div>
        </ng-template>

        <ng-template #allCombinedTable>
          <div class="h-full w-full flex flex-col overflow-hidden">
            <app-data-table
              [data]="tableData"
              [columns]="allColumns"
              sortActive="week_start"
              sortDirection="asc"
              smallRowHeight="true"
              [layoutFixed]="false"
            ></app-data-table>
          </div>
        </ng-template>
      </ng-container>

      <ng-container *ngIf="!selectedOption.isAllAgents && selectedOption && isWeeklyAgentsNotRun">
        <div class="h-full w-full p-4 content-center text-center font-bold">
          <div class="card-info pb-4">This agent hasn’t run yet, so we don’t have any data to show you. Use the
            button below to manually run your agent for the past 7 days.</div>
          <button matButton="filled" (click)="runAgent()">Run Agent</button>
        </div>
      </ng-container>
    }
  </ng-template>
</div>
